import { useQuery } from '@tanstack/react-query'
import { getTempo } from '../../service/list'

function useGetTempo() {
  return useQuery({
    queryKey: ['get-tempo'],
    queryFn: () => getTempo(),
    staleTime: 6 * 1000,
  })
}

export default useGetTempo
